<!--
 * @Description:: 请补充填写
 * @Version: 请配置版本号
 * @Author: xiaobai
 * @Date: 2021-06-11 09:48:04
 * @LastEditors: xiaobai
 * @LastEditTime: 2021-06-15 11:26:52
 * @FilePath: /fujian/src/views/project/index.vue
-->
<template>
  <div>
    <div class="banner_boxa">
    <img :src="bannerUrl" class="banner_imga">
    <div class="bannenr_texta animation"><span>项目案例</span></div>
  </div>
  <div class="tabs_boxes">
    <div class="tabs_box_overflow" style="width: 450px;">
      <div class="tab" @click="gotoPage(index)" :class="{'active':isActive == index}" v-for="(item,index) in tabList" :key="index">{{item}}</div>
    </div>
  </div>
  <router-view></router-view>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  data(){
    return{
      bannerUrl:'',
      isActive:0,
      tabList:['公路工程','市政工程','投资业务','工程检测']
    }
  },
  watch: {
    $route: {
      handler: function (val) {
        if(val.name == 'project_way_index') {
           this.$store.commit('setOpenNav', [4, 0])
            this.isActive = 0
        }
        if(val.name == 'project_government') {
          this.$store.commit('setOpenNav', [4, 1])
          this.isActive = 1
        }
        if(val.name == 'investment_business') {
          this.$store.commit('setOpenNav', [4, 2])
          this.isActive = 2
        }
        if(val.name == 'engineering_inspection') {
          this.$store.commit('setOpenNav', [4, 3])
          this.isActive = 3
        }
      },
    },
  },
  mounted(){
    this.getBanner()
     const openNav = this.$store.state.openNav
     if(openNav) this.isActive = openNav[1]
     else this.isActive = 0
  },
  methods:{
    gotoPage(j){
      this.$store.commit('setOpenNav', [4, j])

      this.isActive = j
      if (j == 0) this.$router.push('/project_way_index')
      else if (j == 1) this.$router.push('/project_government')
      else if (j == 2) this.$router.push('/investment_business')
      else if (j == 3) this.$router.push('/engineering_inspection')

    },
    getBanner() {
      axios.post('/home/img', { projectId: this.$store.state.navList[4].id }).then((res) => {
        const bannerList = res.data.data.imageList
        bannerList.map((item) => {
          this.$set(item, 'imgUrl', res.data.data.imgUrl + '/' + item.url)
        })
        this.bannerUrl = bannerList[0].imgUrl
      })
    },
  }
}
</script>

<style>

</style>